import { createRoutine } from 'redux-saga-routines'

import { Signup } from './constants'
import { ISignupState } from './index.interface'
const initialLoginState: ISignupState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  me: {
    userName: '',
    id: '',
    isUsingLdap: false,
    access_token: ''
  }
}

export const signupUser = createRoutine(Signup)

export default (state = initialLoginState, action: any) => {
  switch (action.type) {
    case signupUser.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: '',
        me: initialLoginState.me
      }
    case signupUser.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: '',
        me: action.payload
      }
    case signupUser.FAILURE:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: action.payload,
        me: initialLoginState.me
      }

    default:
      return { ...state }
  }
}
